<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    width="560px"
    @ok="handleOk"
    @cancel="handleCancel"
    ok-text="确认添加"
    cancel-text="取消"
    :confirm-loading="loading"
  >
    <div slot="title">
      <div class="modal-title">添加客户端</div>
      <div  class="modal-tip">从已有客户端中选择，分配给「<b>{{ tenantName || '当前租户' }}</b>」（不新建客户端）</div>
    </div>

    <div class="filter-bar">
      <a-input-search
        v-model="searchKeyword"
        placeholder="搜索客户端名称 / ClientId"
        style="width: 220px"
        allow-clear
        @pressEnter="loadList"
      />
      <a-select
        v-model="filterCategory"
        placeholder="全部分类"
        style="width: 130px; margin-left: 8px"
        allow-clear
        @change="loadList"
      >
        <a-select-option v-for="item in categoryOptions" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>
      <a-select
        v-model="filterType"
        placeholder="全部类型"
        style="width: 130px; margin-left: 8px"
        allow-clear
        @change="loadList"
      >
        <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>

    <div class="client-list-area" @scroll="handleScroll">
      <a-spin :spinning="loadingList" class="loading-tip" size="small" />
      <div v-if="filteredList.length === 0" class="empty-tip">未找到符合条件的客户端</div>
      <div v-else>
        <div
          v-for="item in filteredList"
          :key="item.id"
          class="client-item"
          :class="{ 'item-disabled': item.allocated }"
        >
          <a-checkbox
            :checked="selectedIds.includes(item.id)"
            :disabled="item.allocated"
            @change="(e) => handleToggle(item, e)"
          >
            <div class="client-info">
              <div class="client-name">
                <span class="name-text">{{ item.clientName }}</span>
                <span class="client-id mono-text">{{ item.clientId }}</span>
              </div>
              <div class="client-meta">
                <a-tag :color="getCategoryColor(item.clientCategory)">{{ getCategoryLabel(item.clientCategory) }}</a-tag>
                <span class="meta-sep">·</span>
                <a-tag :color="getTypeColor(item.clientType)">{{ getTypeLabel(item.clientType) }}</a-tag>
                <span v-if="item.allocated" class="allocated-tag">· 已分配</span>
              </div>
            </div>
          </a-checkbox>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { CLIENT_TYPES, CLIENT_CATEGORIES } from '../../../clientManagement/clientConstants.js'

export default {
  name: 'AddTenantClient',
  props: {
    visible: { type: Boolean, default: false },
    tenantId: { type: String, default: '' },
    tenantName: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      loadingList: false,
      searchKeyword: '',
      filterCategory: undefined,
      filterType: undefined,
      filteredList: [],       // 原始数据（可分配）
      selectedIds: [],   // 选中的 clientId
      categoryOptions: CLIENT_CATEGORIES,
      typeOptions: CLIENT_TYPES,
      page: 1,
      total: 0,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.page = 1
        this.searchKeyword = ''
        this.filterCategory = undefined
        this.filterType = undefined
        this.selectedIds = []
        this.filteredList = []
        this.loadList()
      }
    },
  },
  methods: {
    handleScroll(e) {
      const target = e.target
      if (target.scrollTop + target.clientHeight >= target.scrollHeight && this.total > this.filteredList.length) {
        // TODO: 加载更多
        this.page++
        this.loadList()
      }
    },
    loadList() {
      this.loadingList = true
      const params = {
        tenantId: this.tenantId,
        keyword: this.searchKeyword,
        clientCategory: this.filterCategory,
        clientType: this.filterType,
        status: null,
        tenantName: this.tenantName,
        page: this.page,
        pageSize: 20,
      }
      this.$api.getAvailableClients(params).then((res) => {
        if (res && res.code == 0 && res.data) {
          this.filteredList = [...this.filteredList, ...res.data.records]
          this.total = Number(res.data.total)
        }
      }).catch((err) => {
        console.err(err)
      }).finally(() => {
        this.loadingList = false
      })
    },

    handleToggle(item, e) {
      if (item.allocated) return
      const idx = this.selectedIds.indexOf(item.id)
      if (e.target.checked) {
        if (idx === -1) this.selectedIds.push(item.id)
      } else {
        if (idx > -1) this.selectedIds.splice(idx, 1)
      }
    },

    handleOk() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请至少选择一个客户端')
        return
      }
      this.loading = true
      this.$api.assignClientsToTenant(this.tenantId, { clientIds: this.selectedIds }).then((res) => {
        this.loading = false
        if (res && res.code == 0) {
          this.$message.success('分配成功')
          this.$emit('close')
          this.$emit('refresh')
        } else {
          this.$message.error(res && res.message ? res.message : '分配失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.success('分配成功（模拟）')
        this.$emit('close')
        this.$emit('refresh')
      })
    },

    handleCancel() {
      this.$emit('close')
    },

    /* 工具 */
    getTypeLabel(v) { const t = CLIENT_TYPES.find((i) => i.value === v); return t ? t.label : v },
    getTypeColor(v) { const t = CLIENT_TYPES.find((i) => i.value === v); return t ? t.color : 'blue' },
    getCategoryLabel(v) { const t = CLIENT_CATEGORIES.find((i) => i.value === v); return t ? t.label : v },
    getCategoryColor(v) { return v === 'APPLICATION' ? 'orange' : 'geekblue' },
  },
}
</script>

<style lang="less" scoped>
.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}

.modal-tip {
  font-size: 12px;
  color: #999;
}

.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.client-list-area {
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
}

.loading-tip, .empty-tip {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 13px;
}

.client-item {
  padding: 10px 14px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 8px;
  transition: border-color .2s;
  &:hover { border-color: #1890ff; background: #e6f4ff; }
  &:last-child { margin-bottom: 0; }
  &.item-disabled {
    opacity: .55;
    // .client-info .client-name { text-decoration: line-through; }
  }
  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  .client-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 4px;

    .client-name {
      display: flex;
      align-items: center;
      gap: 10px;
      .name-text {
        font-size: 14px;
        font-weight: 500;
        color: #262626;
      }
      .client-id {
        font-size: 12px;
        color: #999;
      }
    }

    .client-meta {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: #8c8c8c;
      .meta-sep { color: #d9d9d9; }
      .allocated-tag {
        color: #52c41a;
        font-weight: 500;
      }
    }
  }
}

.mono-text { font-family: Menlo, Monaco, Consolas, monospace; }
</style>
